import { render } from "./Meal.vue?vue&type=template&id=331abc51"
import script from "./Meal.vue?vue&type=script&lang=js"
export * from "./Meal.vue?vue&type=script&lang=js"

import "./Meal.vue?vue&type=style&index=0&id=331abc51&lang=css"

import exportComponent from "/sv-shops-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__